import React, { Component } from "react";

import Client from "./client";
import Logger from "../../logger";

import BackendURLForm from "../../Forms/BackendURLForm.jsx";
import CommonWorkflows from "../../Forms/CommonWorkflows.jsx";
import RefundForm from "../../Forms/RefundForm.jsx";
import CartForm from "../../Forms/CartForm.jsx";
import ConnectionInfo from "../../ConnectionInfo/ConnectionInfo.jsx";
import Readers from "../../Forms/Readers.jsx";
import Group from "../../components/Group/Group.jsx";
import Logs from "../../Logs/Logs.jsx";
import { css } from "emotion";

class Checkout extends Component {
  constructor(props) {
    super(props);
    console.log("props---->",props);
    
    this.state = {
      status: "requires_initializing", // requires_connecting || reader_registration || workflows
      backendURL: null,
      discoveredReaders: [],
      connectionStatus: "not_connected",
      reader: null,
      readerLabel: "",
      registrationCode: "",
      cancelablePayment: false,
      chargeAmount: props?.cartTotal * 100,
      itemDescription: "Red t-shirt",
      taxAmount: 100,
      currency: "sgd",
      workFlowInProgress: null,
      discoveryWasCancelled: false,
      refundedChargeID: null,
      refundedAmount: null,
      cancelableRefund: false,
      usingSimulator: false,
      testCardNumber: "",
      testPaymentMethod: "visa",
      tipAmount: null,
      simulateOnReaderTip: false,
      orderId: props?.orderId,
      cart: props.cart,
      customerId: props.stripeCustomer
    };
  }

  componentDidMount() {
    // const searchParams = new URLSearchParams(window.location.search);
    // const orderId = searchParams.get('orderId');
    const orderId = this.props.orderId
    console.log("orderId: ", orderId);
    this.setState({ orderId });
  }

  isWorkflowDisabled = () =>
    this.state.cancelablePayment || this.state.workFlowInProgress;

  runWorkflow = async (workflowName, workflowFn) => {
    console.log(workflowName, workflowFn);
    this.setState({
      workFlowInProgress: workflowName
    });
    try {
      await workflowFn();
    } finally {
      this.setState({
        workFlowInProgress: null
      });
    }
  };
  
 async initializeBackendClientAndTerminal(backendURL) {
    // 1. Verify SDK availability
    if (!window?.StripeTerminal) {
      console.error("StripeTerminal SDK not found");          // Dev log
      alert("Stripe Terminal SDK failed to load. Please refresh the page.");  // User alert
      return null;
    }
  
    // 2. Initialize backend client
    try {
      this.client = new Client(backendURL);
      console.info("Backend Client initialized", backendURL);
    } catch (err) {
      console.error("Client initialization error:", err);
      alert("Unable to initialize backend client."); 
      return null;
    }
  
    // 3. Create Terminal with guarded callbacks
    try {
      // Optionally clear old credentials to avoid stale state :contentReference[oaicite:3]{index=3}
      const terminal = window.StripeTerminal.create({
        onFetchConnectionToken: async () => {
          try {
            const { secret } = await this.client.createConnectionToken();
            if (!secret) throw new Error("Empty connection token");
            return secret;
          } catch (err) {
            console.error("Fetching connection token failed:", err);
            alert("Network error retrieving connection token. Retrying...");
            return null;
          }
        },
        onUnexpectedReaderDisconnect: () => {
          console.warn("Reader disconnected unexpectedly");
          alert("Reader disconnected. Please reconnect.");         // User alert
          this.setState({ connectionStatus: "not_connected", reader: null });
        },
        onConnectionStatusChange: (ev) => {
          console.info("Connection status:", ev.status);
          this.setState({ connectionStatus: ev.status });
        }
      });
  
      // 4. Clear any cached credentials before first use :contentReference[oaicite:4]{index=4}
      try {
        await terminal.clearCachedCredentials();
        console.info("Cleared cached credentials");
      } catch {
        console.warn("No cached credentials to clear");
      }
  
      console.info("Stripe Terminal initialized successfully");
      this.terminal = terminal;
      return terminal;
  
    } catch (err) {
      console.error("Error initializing StripeTerminal:", err);
      alert("Failed to initialize Stripe Terminal. Check console for details.");
      return null;
    }
  }
  
  // 2. Discover and connect to a reader.
  discoverReaders = async () => {
    this.setState({
      discoveryWasCancelled: false
    });

    // 2a. Discover registered readers to connect to.
    const discoverResult = await this.terminal.discoverReaders();

    if (discoverResult.error) {
      console.log("Failed to discover: ", discoverResult.error);
      return discoverResult.error;
    } else {
      if (this.state.discoveryWasCancelled) return;

      this.setState({
        discoveredReaders: discoverResult.discoveredReaders
      });
      return discoverResult.discoveredReaders;
    }
  };

  cancelDiscoverReaders = () => {
    this.setState({
      discoveryWasCancelled: true
    });
  };

  connectToSimulator = async () => {
    const simulatedResult = await this.terminal.discoverReaders({
      simulated: true
    });
    console.log("simulatedResult" , simulatedResult)
    await this.connectToReader(simulatedResult.discoveredReaders[0]);
  };

  connectToReader = async selectedReader => {
    // 2b. Connect to a discovered reader.
    const connectResult = await this.terminal.connectReader(selectedReader);
    console.log("connectResult" , connectResult)
    if (connectResult.error) {
      console.log("Failed to connect:", connectResult.error);
    } else {
      this.setState({
        usingSimulator: selectedReader.id === "SIMULATOR",
        status: "workflows",
        discoveredReaders: [],
        reader: connectResult.reader
      });
      return connectResult;
    }
  };

  disconnectReader = async () => {
    // 2c. Disconnect from the reader, in case the user wants to switch readers.
    await this.terminal.disconnectReader();
    this.setState({
      reader: null
    });
  };

  registerAndConnectNewReader = async (label, registrationCode, location) => {
    try {
      let reader = await this.client.registerDevice({
        label,
        registrationCode,
        location
      });
      // After registering a new reader, we can connect immediately using the reader object returned from the server.
      await this.connectToReader(reader);
      console.log("Registered and Connected Successfully!");
    } catch (e) {
      // Suppress backend errors since they will be shown in logs
    }
  };

  // 3. Terminal Workflows (Once connected to a reader)
  updateLineItems = async () => {
    // 3a. Update the reader display to show cart contents to the customer
    await this.terminal.setReaderDisplay({
      type: "cart",
      cart: {
        line_items: [
          {
            description: this.state.itemDescription,
            amount: this.state.chargeAmount,
            quantity: 1
          }
        ],
        tax: this.state.taxAmount,
        total: this.state.chargeAmount + this.state.taxAmount,
        currency: this.state.currency
      }
    });
    console.log("Reader Display Updated!");
    return;
  };

  // 3b. Collect a card present payment
  // collectCardPayment = async () => {
  //   // We want to reuse the same PaymentIntent object in the case of declined charges, so we
  //   // store the pending PaymentIntent's secret until the payment is complete.
  //   if (!this.pendingPaymentIntentSecret) {
  //     try {
  //       let paymentMethodTypes = ["card_present"];
  //       if (this.state.currency === "cad") {
  //         paymentMethodTypes.push("interac_present");
  //       }
  //       let createIntentResponse = await this.client.createPaymentIntent({
  //         amount: this.state.chargeAmount + this.state.taxAmount,
  //         currency: this.state.currency,
  //         description: "Test Charge",
  //         order_id: this.state.orderId,
  //         metadata: {
  //           orderId: this.state.orderId,
  //           cart: JSON.stringify(this.state.cart)
  //         },
  //         paymentMethodTypes
  //       });
  //       this.pendingPaymentIntentSecret = createIntentResponse.clientSecret;
  //     } catch (e) {
  //       // Suppress backend errors since they will be shown in logs
  //       return;
  //     }
  //   }
    
  //   const simulatorConfiguration = {
  //     testPaymentMethod: this.state.testPaymentMethod,
  //     testCardNumber: this.state.testCardNumber
  //   };

  //   if (this.state.simulateOnReaderTip) {
  //     simulatorConfiguration.tipAmount = Number(this.state.tipAmount);
  //   }

  //   // Read a card from the customer
  //   this.terminal.setSimulatorConfiguration(simulatorConfiguration);
  //   const paymentMethodPromise = this.terminal.collectPaymentMethod(
  //     this.pendingPaymentIntentSecret
  //   );
  //   this.setState({ cancelablePayment: true });
  //   const result = await paymentMethodPromise;
  //   if (result.error) {
  //     console.log("Collect payment method failed:", result.error.message);
  //   } else {
  //     const confirmResult = await this.terminal.processPayment(
  //       result.paymentIntent
  //     );
  //     // At this stage, the payment can no longer be canceled because we've sent the request to the network.
  //     this.setState({ cancelablePayment: false });
  //     if (confirmResult.error) {
  //       alert(`Confirm failed: ${confirmResult.error.message}`);
  //     } else if (confirmResult.paymentIntent) {
  //       if (confirmResult.paymentIntent.status !== "succeeded") {
  //         try {
  //           // Capture the PaymentIntent from your backend client and mark the payment as complete
  //           let captureResult = await this.client.capturePaymentIntent({
  //             paymentIntentId: confirmResult.paymentIntent.id
  //           });
  //           this.pendingPaymentIntentSecret = null;
  //           this.props.clearCartData();
  //           console.log("Payment Successful!");
  //           return captureResult;
  //         } catch (e) {
  //           // Suppress backend errors since they will be shown in logs
  //           return;
  //         }
  //       } else {
  //         this.pendingPaymentIntentSecret = null;
  //         console.log("Single-message payment successful!");
  //         return confirmResult;
  //       }
  //     }
  //   }
  // };
  collectCardPayment = async () => {
    if (!this.pendingPaymentIntentSecret) {
      try {
        let paymentMethodTypes = ["card_present"];
        if (this.state.currency === "cad") {
          paymentMethodTypes.push("interac_present");
        }

        // Include metadata: orderId and cart
        console.log("this.state.customerId---->",this.state.customerId)
        let createIntentResponse = await this.client.createPaymentIntent({
          amount: this.state.chargeAmount + this.state.taxAmount,
          currency: this.state.currency,
          description: "Test Charge",
          customer: this.state.customerId,
          order_id: this.state.orderId,
          metadata: {
            orderId: this.state.orderId,
            cart: JSON.stringify(this.state.cart)
          },
          paymentMethodTypes
        });

        this.pendingPaymentIntentSecret = createIntentResponse.clientSecret;
      } catch (e) {
        return;
      }
    }

    const simulatorConfiguration = {
      testPaymentMethod: this.state.testPaymentMethod,
      testCardNumber: this.state.testCardNumber
    };

    if (this.state.simulateOnReaderTip) {
      simulatorConfiguration.tipAmount = Number(this.state.tipAmount);
    }

    this.terminal.setSimulatorConfiguration(simulatorConfiguration);
    const paymentMethodPromise = this.terminal.collectPaymentMethod(this.pendingPaymentIntentSecret);
    this.setState({ cancelablePayment: true });
    const result = await paymentMethodPromise;
    if (result.error) {
      console.log("Collect payment method failed:", result.error.message);
    } else {
      const confirmResult = await this.terminal.processPayment(result.paymentIntent);
      this.setState({ cancelablePayment: false });
      if (confirmResult.error) {
        alert(`Confirm failed: ${confirmResult.error.message}`);
      } else if (confirmResult.paymentIntent) {
        if (confirmResult.paymentIntent.status !== "succeeded") {
          try {
            let captureResult = await this.client.capturePaymentIntent({
              paymentIntentId: confirmResult.paymentIntent.id
            });
            this.pendingPaymentIntentSecret = null;
            this.props.clearCartData();
         

            console.log("Payment Successful!");
            return captureResult;
          } catch (e) {
            return;
          }
        } else {
          this.pendingPaymentIntentSecret = null;
          console.log("Single-message payment successful!");
          return confirmResult;
        }
      }
    }
  };
  // 3c. Cancel a pending payment.
  // Note this can only be done before calling `processPayment`.
  cancelPendingPayment = async () => {
    await this.terminal.cancelCollectPaymentMethod();
    this.pendingPaymentIntentSecret = null;
    this.setState({ cancelablePayment: false });
  };

  // 3d. Save a card for re-use online.
  saveCardForFutureUse = async () => {
    // First, read a card without charging it using `readReusableCard`
    const readResult = await this.terminal.readReusableCard();
    if (readResult.error) {
      alert(`readReusableCard failed: ${readResult.error.message}`);
    } else {
      try {
        // Then, pass the payment method to your backend client to save it to a customer
        let customer = await this.client.savePaymentMethodToCustomer({
          paymentMethodId: readResult.payment_method.id
        });
        console.log("Payment method saved to customer!", customer);
        return customer;
      } catch (e) {
        // Suppress backend errors since they will be shown in logs
        return;
      }
    }
  };

  // 3e. collectRefundPaymentMethod
  collectRefundPaymentMethod = async () => {
    this.setState({ cancelableRefund: true });
    try {
      const readResult = await this.terminal.collectRefundPaymentMethod(
        this.state.refundedChargeID,
        this.state.refundedAmount,
        "cad"
      );
      if (readResult.error) {
        alert(`collectRefundPaymentMethod failed: ${readResult.error.message}`);
        this.setState({ cancelableRefund: false });
      } else {
        const refund = await this.terminal.processRefund();
        if (refund.error) {
          alert(`processRefund failed: ${refund.error.message}`);
        } else {
          console.log("Charge fully refunded!");
          this.setState({
            cancelableRefund: false,
            refundedAmount: null,
            refundedChargeID: null
          });
          return refund;
        }
      }
    } finally {
      this.setState({ cancelableRefund: false });
    }
  };

  // 3f. cancelCollectRefundPaymentMethod
  cancelPendingRefund = async () => {
    await this.terminal.cancelCollectRefundPaymentMethod();
    this.setState({
      cancelableRefund: false,
      refundedAmount: null,
      refundedChargeID: null
    });
  };

  // 4. UI Methods
  onSetBackendURL = url => {
    if (url !== null) {
      window.localStorage.setItem("terminal.backendUrl", url);
    } else {
      window.localStorage.removeItem("terminal.backendUrl");
    }
    this.initializeBackendClientAndTerminal(url);
    this.setState({ backendURL: url });
  };

  
  updateChargeAmount = amount =>
    this.setState({ chargeAmount: parseInt(amount, 10) });
  updateItemDescription = description =>
    this.setState({ itemDescription: description });
  updateTaxAmount = amount =>
    this.setState({ taxAmount: parseInt(amount || 0, 10) });
  updateCurrency = currency => this.setState({ currency: currency });
  updateRefundChargeID = id => this.setState({ refundedChargeID: id });
  updateRefundAmount = amount => {
    this.setState({ refundedAmount: parseInt(amount, 10) });
  };

  onChangeTestPaymentMethod = testPaymentMethod => {
    this.setState({ testPaymentMethod });
  };

  onChangeTestCardNumber = testCardNumber => {
    this.setState({ testCardNumber });
  };

  onChangeTipAmount = (tipAmount) => {
    this.setState({ tipAmount });
  };

  onChangeSimulateOnReaderTip = (simulateOnReaderTip) => {
    this.setState({ simulateOnReaderTip });
  };

  renderForm() {
    const {
      backendURL,
      cancelablePayment,
      reader,
      discoveredReaders,
      usingSimulator
    } = this.state;
    if (backendURL === null && reader === null) {
      return <BackendURLForm onSetBackendURL={this.onSetBackendURL} />;
    } else if (reader === null) {
      return (
        <Readers
          onClickDiscover={() => this.discoverReaders()}
          onClickCancelDiscover={() => this.cancelDiscoverReaders()}
          onSubmitRegister={this.registerAndConnectNewReader}
          readers={discoveredReaders}
          onConnectToReader={this.connectToReader}
          handleUseSimulator={this.connectToSimulator}
          listLocations={this.client.listLocations}
        />
      );
    } else {
      return (
        <>
          <CommonWorkflows
            workFlowDisabled={this.isWorkflowDisabled()}
            onClickCollectCardPayments={() =>
              this.runWorkflow("collectPayment", this.collectCardPayment)
            }
            onClickSaveCardForFutureUse={() =>
              this.runWorkflow("saveCard", this.saveCardForFutureUse)
            }
            onClickCancelPayment={this.cancelPendingPayment}
            onChangeTestPaymentMethod={this.onChangeTestPaymentMethod}
            onChangeTestCardNumber={this.onChangeTestCardNumber}
            onChangeTipAmount={this.onChangeTipAmount}
            onChangeSimulateOnReaderTip={this.onChangeSimulateOnReaderTip}
            cancelablePayment={cancelablePayment}
            usingSimulator={usingSimulator}
          />
        </>
      );
    }
  }

  render() {
    const { backendURL, reader } = this.state;
    return (
      <div
        className={css`
          align-items: center;
          justify-content: center;
          padding: 24px;
          @media (max-width: 800px) {
            height: auto;
            padding: 24px;
          }
        `}
      >
        <Group direction="column" spacing={30}>
          <Group direction="row" spacing={30} responsive>
            <Group direction="column" spacing={16} responsive>
              {backendURL && (
                <ConnectionInfo
                  backendURL={backendURL}
                  reader={reader}
                  onSetBackendURL={this.onSetBackendURL}
                  onClickDisconnect={this.disconnectReader}
                />
              )}
              {this.renderForm()}
            </Group>
          </Group>
        </Group>
      </div>
    );
  }
}

export default Checkout;
